import React from 'react'

const IconCheckCustom = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>check-1</title><path d="M23.374.287a1.5,1.5,0,0,0-2.093.345L7.246,20.2,2.561,15.511A1.5,1.5,0,1,0,.439,17.632l5.935,5.934a1.525,1.525,0,0,0,2.279-.186l15.066-21A1.5,1.5,0,0,0,23.374.287Z"/></svg>

export default IconCheckCustom;



